<app-dashboard-card>
  <ng-container card-title-icon>
    <mat-icon>bar_chart</mat-icon>
  </ng-container>

  <ng-container card-title-content>
    <div class="header-container">
      <h2>Gráfico de Faturamento</h2>
      <span class="header-info">Exibindo os últimos 12 meses</span>
    </div>
  </ng-container>

  <ng-container card-content>
    <div>
      <canvas id="canvas">{{ chart }}</canvas>
      @if (!revenue) {
        <p-skeleton height="20rem" />
      }
    </div>
  </ng-container>
</app-dashboard-card>
